import { Action } from "@ngrx/store";
import { type } from "../../../util";

export const ActionTypes = {
  FETCH_MVR_CHECK_STATUS: type('[MVR check] fetch MVR check status'),
  STORE_MVR_CHECK_STATUS: type('[MVR check] store MVR check status'),
};

export class FetchMvrCheckStatus implements Action {
  public type = ActionTypes.FETCH_MVR_CHECK_STATUS;

  constructor(public payload?: any) { }
}

export class StoreMvrCheckStatus implements Action {
  public type = ActionTypes.STORE_MVR_CHECK_STATUS;

  constructor(public payload?: any) { }
}

export type TypeAction =
  StoreMvrCheckStatus;